<template>
  <div class="phone-model">

    <div class="box">

      <iframe scrolling="auto" :src="url"></iframe>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      url: ""
    },
    created() {
      this.url = this.$route.query.url.replaceAll("%26", "&")
    }
  }

</script>

<style>
  iframe {

    border-top-width: 0px;
    border-bottom-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
    width: 364px;
    height: 100%;
    overflow-y: hidden;

  }

  * {

    margin: 0;

    padding: 0;

  }

  .box {

    width: 390px;
    height: 745.87024px;
    overflow: hidden;

  }

  .phone-model {
    font-size: 16px;
    background-color: #fff;
    width: 412px;
    height: 832px;
    /* position: fixed; */
    /* left: 48%; */
    /* top: 10px; */
    z-index: 10;
    margin: 0 auto;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    background-image: url(https://v1.uviewui.com/common/iPhoneX_model.png);
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 30px;
    padding: 48px 23px 38px 16px;

  }

</style>



// WEBPACK FOOTER //
// src/page/h5/index.vue